<template>
	<div class="insideBody" ref="Bodyscroll" @scroll="scrollEvent">
		<div class="leavingmessage" v-infinite-scroll="load" infinite-scroll-disabled="disabled">
			<div class="messagefixed" :class="[upBlon ? 'on':'',absoluteBlon ? 'absolute':'']">
				<div class="input">
					<el-input maxlength="500" show-word-limit :autosize="{ minRows: 5, maxRows: 10}" type="textarea" placeholder="请输入内容" v-model="textarea"></el-input>
				</div>
				<div class="messagefixedText clr" @click="upBlon = !upBlon">
					<div class="name">点击即可发布留言</div>
					<div class="icon"></div>
					<div class="btns" @click.stop="submitleavemsg(dataObj,true)">发布留言</div>
				</div>
			</div>
			<template v-if="countpage > 0">
				<div class="list" v-for="(item,index) in tableData" :key="index">
					<div class="nameCon">
						<img :src="$url+item.mainmsg.avatar">
						<div class="tits">{{item.mainmsg.studentname}}</div>
					</div>
					<div class="textCon">
						<div class="tits">发表于 {{item.mainmsg.time}}</div>
						<div class="text">{{item.mainmsg.msg}}</div>
						<div class="communication">
							<ul v-for="(items,indexs) in item.replylist" :key="indexs">
								<li class="clr">
									<div class="name clr fl">
										<img class="img fl" :src="$url+items.avatar" />
										<span class="tit fl">{{items.studentname}}：</span>
									</div>
									<div class="con">
										<span class="text">{{items.msg}}</span>
										<span class="time">{{items.time}}</span>
									</div>
								</li>
							</ul>
							<div class="input">
								<el-input :autosize="{ minRows: 2, maxRows: 10}" type="textarea" placeholder="请输入内容" v-model="item.textarea"></el-input>
							</div>
							<div class="btnText">
								<div class="btn" @click="submitleavemsg(item)">回复</div>
							</div>
						</div>
					</div>
				</div>
			</template>
			<template v-else>
				<div class="noneImg">
					<img src="../../assets/images/none.png">
				</div>
			</template>
			<!-- <p class="noneImg" v-if="disabled && tableData.length > 0">没有更多了</p> -->
		</div>
	</div>
</template>
<script>
import {getleavemsglist,submitleavemsg} from '@/api/control5'
export default {
  data(){
    return {
			textarea: null,
			limit: 10,
			page: 0,
			countpage: 1,
			disabled: false,
			tableData: [],
			dataObj: {},
			upBlon: false,
			absoluteBlon: false
		};
	},
	created(){
	},
	methods:{
		datalist(){
			var that = this;
			getleavemsglist({
				userid: that.utils.storageGet("userinfo").masterid,
				limit: this.limit,
				page: that.page
			}).then(res => {
				that.dataObj = res;
				that.countpage = Math.ceil(res.count / that.limit);
				that.tableData = that.tableData.concat(res.data);
				if(that.page >= that.countpage){
					that.disabled = true;
				};
			});
		},
		load(){
			var that = this;
			this.page += 1;
			that.datalist();
		},
		scrollEvent(row){
			var that = this;
			if(that.$refs.Bodyscroll.scrollTop > 100){
				that.absoluteBlon = true;
			}else{
				that.absoluteBlon = false;
			};
		},
		submitleavemsg(item,blon){
			var that = this,textarea = blon ? that.textarea:item.textarea;
			if(textarea == undefined || !textarea.trim()){
				that.$message.error('请输入内容');
				return false;
			};
			submitleavemsg({
				userid: that.utils.storageGet("userinfo").userid,
				msgid: blon ? '':item.mainmsg.id,
				sendtoid: '',
				msg: blon ? that.textarea:item.textarea
			}).then(res => {
				if(!blon){
					var obj = { //模拟回复
						avatar: that.utils.storageGet("userinfo").avatar,
						id: item.mainmsg.id,
						msg: item.textarea,
						sendto: item.mainmsg.sendto,
						sendtoname: item.mainmsg.sendtoname,
						studentid: that.utils.storageGet("userinfo").userid,
						studentname: that.utils.storageGet("userinfo").username,
						time: that.defaultDate()
					};
					item.replylist.push(obj);
					that.$message.success('回复成功');
				}else{
					that.$message.success('提交留言成功');
					that.tableData=[];
					that.datalist();
				};
			});
		},
		defaultDate(){
			 var that = this,date = new Date(),year = date.getFullYear(),month = date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1):(date.getMonth()+1),da = date.getDate() < 10 ? '0'+date.getDate():date.getDate(),houram = date.getHours() > 12 ? date.getHours() - 12:date.getHours(),hour = houram < 10 ? '0'+houram:houram,minute = date.getMinutes() < 10 ? '0'+date.getMinutes():date.getMinutes(), date = year+'-'+month+'-'+da+' '+hour+':'+minute;
			return date;
		},
	},
	mounted(){
	},
	components: {
		
	},
}
</script>
<style scoped>
	
</style>